import type { FaireProductEntity } from "../../entity_types/product";

export const p_nh54rp6a79: FaireProductEntity = {
  token: "p_nh54rp6a79",
  type: "product",
  name: "Crystal Troll Doll Refrigerator Magnet",
  brandToken: "b_nwecvb9e2v",
  brandName: "Enchanted Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/2da1ac67258f1e83f56a4ac602fb8b5d7d35b10c0488527f6971fac68f8b1c70.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd6675cd6c5cb8a819f5dd32fcf4ac91959642d486d169e0b0a75baeb70b7c5b.png",
    "https://cdn.faire.com/fastly/f1c3eadd9b814fd460511ef1f882dcb98db0d770e0dead36e9476c8450ee5a31.png",
    "https://cdn.faire.com/fastly/d06ceedf8e8f414a5cebfd1c248b139be22616c9ffabcf8b972f41b822f58904.png",
  ],
  priceDollars: 6.91,
  description:
    "Add a touch of whimsy and good vibes to your kitchen with these handmade Crystal Troll Doll Magnets. Each troll doll features wild, colorful hair and holds a unique natural crystal, creating a fun and uplifting energy wherever you place them.\n\n * Assorted Troll Dolls & Crystals – Each magnet comes with a randomly selected troll doll in a vibrant hair color, paired with an intuitively chosen crystal such as hematoid quartz (from our own crystal mine), clear quartz, fluorite, and more.\n\n * Handcrafted with Care – These troll magnets are hand-assembled by us, ensuring each one is full of character and charm.\n\n * Perfect Gift or Collector’s Item – Ideal for crystal lovers, troll doll collectors, or anyone who wants to bring a little joy and magic to their fridge or workspace.\n\nPlease note: Colors and crystals vary, making each piece one-of-a-kind. Let your intuition guide you to the troll that’s meant for you!\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:15.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
